import type { TPasskeyOutcome } from '@besuites/auth/browser';

export default function passkeyProblemOf(outcome: TPasskeyOutcome): string | null {
    if (outcome.status === 'ok') return null;
    if (outcome.status === 'unsupported') return 'Questo browser non supporta le passkey.';
    if (outcome.status === 'invalid') return 'Il browser non ha accettato la richiesta della passkey. Riprova.';
    switch (outcome.reason) {
        case 'not-allowed': return 'Operazione annullata o scaduta. Riprova quando sei pronto.';
        case 'excluded': return 'Su questo dispositivo hai già una passkey per il gestionale.';
        case 'security': return 'Questa pagina non è autorizzata a usare le passkey del gestionale.';
        case 'aborted': return 'Operazione interrotta.';
        default: return 'La passkey non ha funzionato. Riprova o usa un altro metodo.';
    }
}
